import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  private secretKey : string  = environment.collecteKVAR ;

  constructor() { 

  }

  // setItem(key: string): void {
  //   //LocalStorageSlim.set(key, value);
  //    const infoUser = CryptoJS.AES.encrypt(key, this.secretKey).toString();
  //   localStorage.setItem('infoUser',infoUser);
  // }

  setItem(key: string, value: any): void {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey).toString();
    localStorage.setItem(key, encryptedValue);
  }
  getItem(key: string): any {
    const encryptedValue = localStorage.getItem(key);
    if (encryptedValue) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedValue, this.secretKey);
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedValue);
      } catch (e) {
        console.error("Error decrypting data:", e);
        return null;
      }
    }
    return null;
  }

  removeItem(key: string): void {
    //LocalStorageSlim.remove(key);
    localStorage.removeItem(key);
  }
}

